/* eslint-disable prefer-rest-params */
/* eslint-disable no-param-reassign */
/* eslint-disable no-else-return */
import { Modal } from 'antd'
import apiHost from '@console/request/domains/common/index'
import universalLogin, { getUniversalLoginInfo, universalRegister } from '@/utils/universalLogin'
import { getQuery } from '@/utils/query-string'

export async function getI18n(setLang = 'zh') {
  const { localeLang } = window as any
  const { getLocaleLanguage } = window as any
  const { lang } = getLocaleLanguage(window.navigator, '')
  const project = 'open-platform'
  const defaultLang = 'zh'
  const changeLang = setLang
  // 可通过传当前需要语言方式获取对应语言文件内容
  const data = await localeLang(window.navigator, project, defaultLang, changeLang)
  return { data, currentLang: lang }
}

export function isH5() {
  const sUserAgent = navigator.userAgent.toLowerCase()
  const regList = [/ipad/i, /iphone os/i, /midp/i, /rv:1.2.3.4/i, /ucweb/i, /android/i, /windows ce/i, /windows mobile/i]
  return regList.some((reg) => reg.test(sUserAgent))
}

export function getCookie(name: string) {
  try {
    const bikky = document.cookie
    name += '='
    let i = 0
    while (i < bikky.length) {
      const offset = i + name.length
      if (bikky.substring(i, offset) === name) {
        let endstr = bikky.indexOf(';', offset)
        if (endstr === -1) {
          endstr = bikky.length
        }
        const returnValue = decodeURI(bikky.substring(offset, endstr))
        return returnValue
      }
      i = bikky.indexOf(' ', i) + 1
      if (i === 0) {
        break
      }
    }
  } catch (e: any) {
    throw new Error(e)
  }
}

export function getBase64(img: Blob, callback: { (imageUrl: any): any; (arg0: string | ArrayBuffer | null): any }) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

const Global: any = global

export function handlerCnames(domains: any[]) {
  return new Promise((reslove) => {
    let { apiUser, account, zuul, userInfoHost } = apiHost

    domains.forEach((domainsItem: { cnames: Array<string>; host: string }) => {
      const curHost = domainsItem.cnames[0]
      const curDefaultHost = domainsItem.host
      if (curHost.includes('account')) {
        account = `https://${curHost || curDefaultHost}/`
      }
      if (curHost.includes('api-user')) {
        apiUser = `https://${curHost || curDefaultHost}/`
      }
      if (curHost.includes('api-mifit')) {
        userInfoHost = `https://${curHost || curDefaultHost}/`
      }
      if (curHost.includes('auth')) {
        zuul = `https://${curHost || curDefaultHost}/`
      }
    })
    Global.hostConfig = {
      ...apiHost,
      apiUser,
      account,
      zuul,
      userInfoHost
    }
    reslove(Global.hostConfig)
  })
}
export function throttle(func: any, wait: number, options: { leading: boolean; trailing: boolean }) {
  let context: any
  let args: any
  let startTime = 0
  let timeId: any
  options = options || {}
  const { leading } = options
  const { trailing } = options

  const throttled = function (this: any) {
    const now = +new Date()
    if (!startTime && !leading) startTime = now
    const remaining = wait - (now - startTime)

    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeId) {
        clearTimeout(timeId)
        timeId = null
      }
      startTime = now
      func.apply(context, args)
    } else if (!timeId && trailing) {
      timeId = setTimeout(function () {
        startTime = leading ? 0 : +new Date()
        timeId = null
        func.apply(context, args)
      }, remaining)
    }
  }

  return throttled
}

// 判断表单是否有错误信息
export function isFieldsHasError(fieldsList: any[]): boolean {
  let hasError = false
  for (const fieldItem of fieldsList) {
    if (fieldItem.errors.length > 0) {
      hasError = true
      return true
    }
  }
  return hasError
}

// 根据语言获取应用显示名称
export function getAppName(currentLang = 'zh', appName: string, appNameEn: string) {
  if (appName && currentLang.includes('zh')) {
    return { key: 'appName', value: appName }
  } else if (appNameEn && currentLang.includes('en')) {
    return { key: 'appNameEn', value: appNameEn }
  } else {
    // eslint-disable-next-line
    return appName ? { key: 'appName', value: appName } : appNameEn ? { key: 'appNameEn', value: appNameEn } : { key: 'appName', value: '' }
  }
}

export function getLang() {
  const { getLocaleLanguage } = window as any
  const { lang } = getLocaleLanguage && getLocaleLanguage(window.navigator, 'en')
  const language = lang !== 'zh' && lang !== 'en' ? 'en' : lang
  const storageLang = localStorage.getItem('curLang')
  return storageLang || language || 'en'
}

export function handleOpenPlatformLogin() {
  // 启用zepp域名
  const stagingUrl = 'https://console-staging.zepp.com/#/'
  const prodUrl = 'https://console.zepp.com/#/'
  const regx = /^(https?):\/\/([0-9a-zA-Z]-*)+.zepp.com/
  const domain = 'zepp.com'
  const isPro = process.env.NODE_ENV === 'production'
  let redirectUrl = isPro ? prodUrl : stagingUrl
  const curLang = getLang()

  const { referer } = getQuery()
  if (referer && regx.test(referer as string)) {
    redirectUrl = referer as string
  }
  universalLogin({
    projectName: 'open_platform',
    redirectUrl,
    platformAppName: 'com.huami.webapp',
    specifyLang: curLang,
    domain
  })
}

export function handleOpenPlatformRegister() {
  const isPro = process.env.NODE_ENV === 'production'
  // 启用zepp域名
  const stagingUrl = 'https://console-staging.zepp.com/#/'
  const prodUrl = 'https://console.zepp.com/#/'
  const domain = 'zepp.com'

  const redirectUrl = isPro ? prodUrl : stagingUrl
  const curLang = getLang()

  universalRegister({
    projectName: 'open_platform',
    redirectUrl,
    platformAppName: 'com.huami.webapp',
    specifyLang: curLang,
    domain
  })
}

let expiredAppTokenInstance: any = null
export function expiredAppTokenValid() {
  if (!expiredAppTokenInstance) {
    const currentLang = getLang()
    expiredAppTokenInstance = Modal.confirm({
      title:
        currentLang === 'zh'
          ? '登录状态过期，请尝试刷新页面或者重新登录'
          : 'The login status has expired. Please try to refresh the page or login again',
      okText: currentLang === 'zh' ? '去登录' : 'Login',
      cancelText: currentLang === 'zh' ? '刷新页面' : 'Refresh',
      onOk: () => {
        handleOpenPlatformLogin()
      },
      onCancel: () => {
        window.location.reload()
      }
    })
  }
}

let verifyAppTokenInstance: any = null
export function verifyAppTokenValid() {
  if (!verifyAppTokenInstance) {
    const currentLang = getLang()
    verifyAppTokenInstance = Modal.warning({
      title: currentLang === 'zh' ? '未登录华米账号' : 'Not logged into Zepp account',
      okText: currentLang === 'zh' ? '去登录' : 'Login',
      onOk: () => {
        handleOpenPlatformLogin()
      }
    })
  }
}

let verifyExamineInstance: any = null
export function verifyExamine() {
  const currentLang = getLang()
  if (verifyExamineInstance) {
    verifyExamineInstance.destroy()
  }
  verifyExamineInstance = Modal.warning({
    maskClosable: true,
    title: currentLang === 'zh' ? '未完成华米开发者认证' : 'Need To Sign Up As a Developer',
    okText: currentLang === 'zh' ? '去认证' : 'To Sign Up',
    onOk: () => {
      window.location.href = `/#/user/register/auth/enterprise?lang=${currentLang}`
    }
  })
}

export function getAppToken() {
  const { appToken } = getUniversalLoginInfo()
  if (!appToken) {
    return verifyAppTokenValid()
  }

  return appToken
}

// 获取二级域名 second-level domain
export function getSLD() {
  const domain = window.location.hostname
  const sld = domain.split('.').reverse()[1]

  return sld || 'zepp'
}

// 合并 img1 和 img2 图片，将 img2 图片合并到 img1 图片上，返回合并后的图片
export function mergeImage(img1: any, img2: any): Promise<string> {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
  const image1 = new Image()
  const image2 = new Image()

  image1.src = img1

  return new Promise((resolve, reject) => {
    image1.onload = () => {
      canvas.width = image1.width
      canvas.height = image1.height
      ctx.drawImage(image1, 0, 0)
      image2.src = img2

      image2.onload = () => {
        ctx.drawImage(image2, 0, 0)
        resolve(canvas.toDataURL('image/png'))
      }
      image2.onerror = (e) => {
        console.error(e)
        reject(new Error('image2 加载失败'))
      }
    }
    image1.onerror = (e) => {
      console.error(e)
      reject(new Error('image1 加载失败'))
    }
  })
}


export function convertDataUrlToFile(dataUrl: string, fileName: string) {
  const fileType = dataUrl.split(';')[0].split(':')[1];
  const fileData = atob(dataUrl.split(',')[1]);

  // 将数据内容转换为 Uint8Array 数组
  const dataArray = new Uint8Array(fileData.length);

  for (let i = 0; i < fileData.length; i += 1) {
    dataArray[i] = fileData.charCodeAt(i);
  }

  // 创建文件对象并上传
  const file = new File([dataArray], fileName, { type: fileType });

  return file
}
